import { AccountType } from '../api'

const {
  Admin,

  Mentee,
  Mentor,
  CompanyMentoring,
  BlcMentoring,

  Coachee,
  Coach,
  CompanyCoaching,
  BlcCoaching,
} = AccountType

export type PermissionCheck = (accessor?: AccountType) => boolean

const genPermissionCheck =
  (permission: AccountType []): PermissionCheck =>
    accessor =>
      !!accessor && permission.indexOf(accessor) !== -1

export const hasDocumentationInProcess =
  genPermissionCheck([
    Admin,
    Mentor,
    Coach,
    CompanyMentoring,
    CompanyCoaching,
    BlcMentoring,
    BlcCoaching
  ])

export const hasProgramSummary =
  genPermissionCheck([
    Admin,
    Mentor,
    Coach,
    CompanyMentoring,
    CompanyCoaching,
    BlcMentoring,
    BlcCoaching
  ])

export const canInteractWithProcess =
  genPermissionCheck([
    Mentee,
    Coach,
  ])

export const canInteractWithTripartita =
  genPermissionCheck([
    Coach,
    Coachee,
  ])

export const isAdmin =
  genPermissionCheck([
    Admin,
    BlcMentoring,
    BlcCoaching,
  ])

export const isTeacher =
  genPermissionCheck([
    Mentor,
    Coach,
  ])

export const isStudent =
  genPermissionCheck([
    Mentee,
    Coachee,
  ])

export const seesAllPeopleInProcess =
  genPermissionCheck([
    CompanyCoaching,
    CompanyMentoring,
    BlcMentoring,
    BlcCoaching,
    Admin,
  ])

export const isInMentoring =
  genPermissionCheck([
    BlcMentoring,
    CompanyMentoring,
    Mentor,
    Mentee,
  ])

export const isInCoaching =
  genPermissionCheck([
    BlcCoaching,
    CompanyCoaching,
    Coach,
    Coachee,
  ])

export const getsPromptedForContract =
  genPermissionCheck([
    Coach,
    Coachee,
    Mentor,
    Mentee,
  ])

export const hasToAcceptContract =
  genPermissionCheck([
    Coach,
  ])

export const canUploadProcessResources =
  genPermissionCheck([
    Coach,
    Coachee,
    Mentor,
    Mentee,
    BlcCoaching,
    BlcMentoring,
  ])

export const canEditFinalEvaluation =
  genPermissionCheck([
    Coach,
    Coachee,
    BlcCoaching,
  ])



// WEBPACK FOOTER //
// ./src/project-utils/permissions.ts